import React, { createRef, useState, useEffect } from 'react';
import withSizes from 'react-sizes';

import CoinCard from './CoinCard';

import log from '../services/log';
import fetcher from '../services/fetcher';
import auth from '../services/auth';

import UnlockProCard from './UnlockProCard';

function TradingViewPanel(props) {
  const _ref = createRef();
  const [alertsHistory, setAlertsHistory] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const shouldShowPaywall = !auth.isProMembership() && !auth.isFreeTrial() && !props.isPage;

  async function getAlertsHistory(){
    setIsLoading(true)
    const alertsHistory = await fetcher.getAlertsHistory(props.coin.coin)
    if (alertsHistory){
        setIsLoading(false)
        setAlertsHistory(alertsHistory)
    }
  }

  useEffect(() => {
    if (props.coin){
      getAlertsHistory()
      refreshWidget()
    }
  }, [props.coin, props.darkmode]);

  const refreshWidget = () => {
      _ref.current.innerHTML = "";
      log.trace('refreshWidget')

      const tvdDiv = document.createElement('div');
      tvdDiv.setAttribute('style', 'height: 600px')
      tvdDiv.innerHTML = `<div id="tradingview_266d5" style="height: 600px"></div>`;
      _ref.current.appendChild(tvdDiv);

      const tvScript = document.createElement('script');
      tvScript.innerHTML = `new TradingView.widget({
      "symbol": "BINANCE:${props.coin.coin}USDT",
      "interval": "4H",
      "timezone": "Etc/UTC",
      "theme": ${props.darkmode ? "'dark'" : "'light'"},
      "style": "1",
      "locale": "en",
      "toolbar_bg": "#f1f3f6",
      "enable_publishing": false,
      "allow_symbol_change": true,
      "container_id": "tradingview_266d5",
      "autosize" : true,
      "studies":[
          "RSI@tv-basicstudies"
      ]
      });`;

      _ref.current.appendChild(tvScript);
  }

  return (
    <div>
      {props.coin &&
        <>
          <CoinCard tv={true} coin={props.coin} onCoinSelected={() => {}}></CoinCard>    
          {shouldShowPaywall  &&
            <div className="row">
              <div className="col-12">
                <UnlockProCard text={'Unlock Access to Trading View RSI Charts'}></UnlockProCard>
              </div>
            </div>
          }
          <div class={`tradingview-widget-container m-2 ${shouldShowPaywall ? 'blurred' : ''}`} ref={_ref}>
          </div>
          {/*<div className="mt-4 mb-2">
            <span className="h5 text-muted">{props.coin.coin} RSI Alerts History</span>
          </div>
          <div style={{ overflowY: 'auto', height: 'auto', maxHeight: 400+'px'}}>
          <AlertsHistoryList coin={props.coin}></AlertsHistoryList>
      </div>*/}
        </>
      }
    </div>
  );
};

TradingViewPanel.defaultProps = {
  isPage: false
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(TradingViewPanel);
